export default "__VITE_ASSET__CCrFZQdc__"